import React, { useEffect, useState } from "react";
import ContactForm from "../../components/ContactForm/ContactForm";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import FAQSection from "../../sections/FAQSection/FAQSection";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Reservations from "../../components/Reservations/Reservations";

const categories = ["general", "media", "events", "career", "Guest list"];

const ContactPage = () => {
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const allSections = [];

        for (let cat of categories) {
          const snapshot = await getDocs(
            collection(db, "faqs", cat, "items")
          );

          const items = snapshot.docs
            .map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
            .sort((a, b) => a.order - b.order);

          if (items.length > 0) {
            allSections.push({
              section: cat.charAt(0).toUpperCase() + cat.slice(1),
              items: items.map((item) => ({
                question: item.question,
                answer: item.answer,
              })),
            });
          }
        }

        setFaqData(allSections);
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  return (
    <div>
      <div style={{ backgroundColor: '#000', paddingTop: '74px' }}>
        <Reservations />
      </div>
      <ContactForm />
      <ContactInfo />

      {loading ? (
        <div style={{ color: "#fff", padding: "40px", textAlign: "center" }}>
          Loading FAQs...
        </div>
      ) : (
        <FAQSection faqData={faqData} />
      )}
    </div>
  );
};

export default ContactPage;